import React, { useState } from 'react';
import '../../../B2BBuyerSeller/B2BProfile/Slot/BookingSystem.css';
import CommProfileHeader from '../../../Exhibitor/Profile/CommProfileHeader';
import MeetingBooking from '../../../B2BBuyerSeller/B2BProfile/MyMeetingRequest/MeetingBooking';
import MyMeetingRequestList from '../../../B2BBuyerSeller/B2BProfile/MyMeetingRequest/MyMeetingRequestList';
import { useExhibitorAuthContext } from '../../../../Context/AuthContex/ExhibitorAuthContext';

const ExhibitorMeetingRequest: React.FC = () => {
  const [toggle, setToggle] = useState<boolean>(false);
  const {
    state: { exhibitorUser },
    dispatch: authDispatch,
  } = useExhibitorAuthContext();

  return (
    <>
      <CommProfileHeader
        addHeadingTitle={`Add Meeting Request`}
        listHeadingTitle='My Meeting Request List'
        createBtnText='Create Meeting Request'
        toggle={toggle}
        setToggle={setToggle}
      />
      {toggle ? (
        <MeetingBooking
          type='Exhibitor'
          user_id={Number(exhibitorUser?.user_fair_member_id) as number}
        />
      ) : (
        <MyMeetingRequestList
          type='Exhibitor'
          user_id={Number(exhibitorUser?.user_fair_member_id) as number}
        />
      )}
    </>
  );
};

export default ExhibitorMeetingRequest;
